import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { useUserType } from "@/hooks/useUserType";
export function Footer() {
  const {
    userType
  } = useUserType();
  const showCandidateSection = userType === null || userType === 'candidate';
  const showCompanySection = userType === null || userType === 'company';
  return <footer className="bg-foreground text-background">
      <div className="container py-[48px]">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl font-display font-bold"><span className="text-accent">JobWay</span><span className="text-primary">X</span></span>
            </div>
            <p className="text-sm text-background/70 mb-4">
              Conectando talentos às melhores oportunidades do mercado.
            </p>
          </div>

          {showCandidateSection && <div>
              <h4 className="font-display font-semibold mb-4">Para Candidatos</h4>
              <ul className="space-y-2 text-sm text-background/70">
                <li><Link to="/vagas" className="hover:text-background transition-colors">Buscar Vagas</Link></li>
                <li><Link to="/entrar" className="hover:text-background transition-colors">Cadastrar Currículo</Link></li>
                <li><Link to="/entrar" className="hover:text-background transition-colors">Acessar Painel</Link></li>
                <li><Link to="/dicas" className="hover:text-background transition-colors">Dicas de Carreira</Link></li>
              </ul>
            </div>}

          {showCompanySection && <div>
              <h4 className="font-display font-semibold mb-4">Para Empresas</h4>
              <ul className="space-y-2 text-sm text-background/70">
                <li><Link to="/entrar" className="hover:text-background transition-colors">Cadastrar Empresa</Link></li>
                <li><Link to="/entrar" className="hover:text-background transition-colors">Publicar Vagas</Link></li>
                <li><Link to="/planos" className="hover:text-background transition-colors">Planos e Preços</Link></li>
                <li><Link to="/contato" className="hover:text-background transition-colors">Fale Conosco</Link></li>
              </ul>
            </div>}

          <div>
            <h4 className="font-display font-semibold mb-4">Contato</h4>
            <ul className="space-y-3 text-sm text-background/70">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary" />
                (43) 99665-9984
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary" />
                contato@jobwayx.com.br
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/50">
          <p>© 2026 <span className="text-accent">JobWay</span><span className="text-primary">X</span> Todos os direitos reservados.</p>
          <div className="flex gap-4">
            <Link to="/privacidade" className="hover:text-background transition-colors">Privacidade</Link>
            <Link to="/termos" className="hover:text-background transition-colors">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </footer>;
}